import { render, staticRenderFns } from "./FoodConsumptionRecord.vue?vue&type=template&id=50ef77f7&scoped=true&lang=html&"
import script from "./FoodConsumptionRecord.vue?vue&type=script&lang=js&"
export * from "./FoodConsumptionRecord.vue?vue&type=script&lang=js&"
import style0 from "./FoodConsumptionRecord.vue?vue&type=style&index=0&id=50ef77f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ef77f7",
  null
  
)

export default component.exports